import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject, Observable, BehaviorSubject} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {StepScreenModel} from '../../../../shared/step/step-screen.component';
import {DeaRegistrationInformationService} from '../../../../../domain/model/licenses-certifications/dea/info/dea-registration-information.service';
import {DeaRegistrationInformation} from '../../../../../domain/model/licenses-certifications/dea/info/dea-registration-information.model';
import {FormErrors} from '../../../../../components/forms/validation/form-validator.class';
import {coerceBooleanProperty} from '../../../../../common/value/coercion/boolean-coercion.util';

@Component({
    template: require('./dea-registration-information-screen.component.html')
})
export class DeaRegistrationInformationScreenComponent {

    constructor(readonly modelService: DeaRegistrationInformationService,
                readonly route: ActivatedRoute) {

        modelService.doesCurrentUserModelExist().subscribe(value => this._deaRegistrationInformationExists = value);

        this.hasDeaRegistration$ = this.hasDeaRegistrationChange$
            .filter(value => !value || !this._deaRegistrationInformationExists || confirm('Changing this answer will cause this data to be deleted?'))
            .publishReplay(1).refCount();

        this.hasDeaRegistration$.subscribe(value => {
            if (value) {
                (<Observable<any>>(this._deaRegistrationInformationExists ? modelService.deleteCurrentUserModel() : Observable.of(true)))
                    .subscribe(() => this.stepScreenModel.goToPreviousScreen());
            }
        });
    }

    _deaRegistrationInformationExists: boolean = false;

    hasDeaRegistrationChange$ = new BehaviorSubject<boolean>(false);
    hasDeaRegistration$: Observable<boolean>;

    changeHasDeaRegistrationAnswer(value: boolean, event) {
        event.preventDefault();
        setTimeout(() => this.hasDeaRegistrationChange$.next(coerceBooleanProperty(value)));
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    stepScreenModel = new StepScreenModel<DeaRegistrationInformation>({
        initialDataModel: new DeaRegistrationInformation(),
        specificValidationMessages: {},
        _loadDataFn: () => {
            return this.modelService.getCurrentUserModel();
        },
        _submitDataFn: (model: DeaRegistrationInformation) => {
            return this.modelService.updateCurrentUserModel(model);
        }
    });

    get model(): DeaRegistrationInformation {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/dea/dea-registration-information/dea-registration-information-screen.component.ts